import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=b8ddc388&scoped=true"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=b8ddc388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ddc388",
  null
  
)

export default component.exports